import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

export const crearSucursal = async (
	nombre,
	direccion,
	telefono,
	mensajeRetiro,
	horaApertura,
	horaCierre,
	imagen,
	pickUp,
	token,
) => {
	let body = {
		nombre: nombre,
		direccion: direccion,
		telefono: telefono,
		mensaje_retiro: mensajeRetiro,
		hora_apertura: horaApertura,
		hora_cierre: horaCierre,
		imagen: imagen,
		pick_up: pickUp !== undefined ? pickUp : true, // Default true
	};

	try {
		const response = await apiClient.post('/sucursales/create', body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				throw new Error(errorData.error || 'Se produjo un error desconocido.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
